export default function formatarDate(date) {
  if (Array.isArray(date)) {
    const [year, month, day] = date;
    return `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${year}`;
  } else if (typeof date === "string" && date.includes("-")) {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }
}
